(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bach-product-details"]) return;
  try {
    
  if (!customElements.get('bach-variant-details')) {
    customElements.define('bach-variant-details', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.openFields = [];
        this.group = this.closest('[data-bach-accordion-group]');
        this.accordionSelector = '.bach-variant-accordion, accordion-toggle > details';
        this.prepareAccordions = () => {
          this.group?.querySelectorAll(this.accordionSelector).forEach(el => {
            el.setAttribute('name', this.group.dataset.bachAccordionGroup);
          });
        };
        this.prepareAccordions();
        this.group?.addEventListener('toggle', event => {
          const opened = event.target;
          if (!opened.matches(this.accordionSelector) || !opened.open) return;
          this.group.querySelectorAll(this.accordionSelector).forEach(el => {
            if (el !== opened) el.open = false;
          });
          if (!this.contains(opened)) this.openFields = [];
        }, { capture: true, signal: this.controller.signal });
        this.eventName = `variant:change:${this.dataset.mainSectionId}:${this.dataset.productId}`;
        this.handleChange = ({ detail }) => {
          const target = this.querySelector('[data-bach-details]');
          const status = this.querySelector('[data-bach-status]');
          if (detail.loading) {
            this.openFields = [...target.querySelectorAll('details[open]')].map(el => el.dataset.bachField);
            target.hidden = true;
            this.setAttribute('aria-busy', 'true');
            status.textContent = this.dataset.loading;
            status.hidden = false;
            return;
          }
          this.removeAttribute('aria-busy');
          const source = detail.html?.querySelector(`template[data-bach-variant-content][data-product-id="${this.dataset.productId}"]`);
          if (!detail.variant || !source || source.dataset.variantId !== String(detail.variant.id)) {
            target.hidden = true;
            status.textContent = this.dataset.error;
            status.hidden = false;
            return;
          }
          target.replaceChildren(source.content.cloneNode(true));
          this.prepareAccordions();
          const otherIsOpen = [...(this.group?.querySelectorAll(this.accordionSelector) || [])]
            .some(el => el.open && !this.contains(el));
          for (const field of otherIsOpen ? [] : this.openFields.slice(0, 1)) {
            const accordion = target.querySelector(`details[data-bach-field="${field}"]`);
            if (accordion) accordion.open = true;
          }
          target.hidden = false;
          status.hidden = true;
        };
        document.addEventListener(this.eventName, this.handleChange, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
